import { Permission } from '../../../components/Authorize/permissions';

export const METRICS = new Permission('main_header_liveMetric', 'User can extend the drawer and view live metrics');
export const EVENT_CONTROLS = new Permission('main_header_powerBtn', 'User can see the power button that allows to change event status and switch cameras');
export const CAMERA_STATUS = new Permission('main_header_camStatus', 'User will see cameras status in header');
